var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbItems}}),_c('Inspection',{attrs:{"asset-meta-index":_vm.assetMetaIndex,"inspection-config":_vm.inspectionConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }